<template>
  <div>
    <el-row v-if="DataCustomerAddress.length === 0">Data Tidak ada di select</el-row>
    <el-row v-else class="mt-4">
      <el-row>
        <el-col :span="12">
          <el-form-item size="small" prop="oracleSiteUseId" label="Oracle Site Use ID">
            <el-col :span="12">
              <el-input disabled v-model="shipToAddress['oracleSiteUseId']" type="number"></el-input>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item size="small" prop="status" label="Status">
            <el-col :span="12">
              <el-select disabled v-model="shipToAddress['status']" style="width: 100%">
                <el-option
                  v-for="item in OptionsActive"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="mb-3">
        <el-col :span="24">
          <el-divider content-position="left">Ship To Address</el-divider>
        </el-col>
      </el-row>

      <el-row>
        <template v-for="(form, idx) in formShipToAddress">
          <el-col :span="12" :key="idx">
            <el-form-item
              v-if="idx >= 0 && idx <= 5"
              size="small"
              :prop="form.id"
              :label="form.label"
              :rules="form.rules"
            >
              <el-col :span="12">
                <el-input
                  disabled
                  v-if="form.type == 'text' || form.type == 'number'"
                  v-model="shipToAddress[form.id]"
                  :type="form.type"
                  :placeholder="`Please input ${form.label}`"
                ></el-input>
                <el-select
                  v-else-if="form.type == 'select'"
                  disabled
                  v-model="shipToAddress[form.id]"
                  :placeholder="`Please select ${form.label}`"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in form.data"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </template>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item
            size="small"
            :prop="formShipToAddress[6].id"
            :label="formShipToAddress[6].label"
            :rules="formShipToAddress[6].rules"
          >
            <el-col :span="18">
              <el-input
                disabled
                v-model="shipToAddress[formShipToAddress[6].id]"
                :type="formShipToAddress[6].type"
                :placeholder="`Please input ${formShipToAddress[6].label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item
            size="small"
            :prop="formShipToAddress[7].id"
            :label="formShipToAddress[7].label"
            :rules="formShipToAddress[7].rules"
          >
            <el-col :span="18">
              <el-input
                disabled
                v-model="shipToAddress[formShipToAddress[7].id]"
                :type="formShipToAddress[7].type"
                :placeholder="`Please input ${formShipToAddress[7].label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <template v-for="(form, idx) in formShipToAddress">
          <el-col :span="12" :key="idx">
            <el-form-item
              v-if="idx >= 8 && idx <= 10"
              size="small"
              :prop="form.id"
              :label="form.label"
              :rules="form.rules"
            >
              <el-col :span="12">
                <el-input
                  disabled
                  v-if="form.type == 'text' || form.type == 'number'"
                  v-model="shipToAddress[form.id]"
                  :type="form.type"
                  :placeholder="`Please input ${form.label}`"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </template>
      </el-row>

      <el-row>
        <template v-for="(form, idx) in formShipToAddress">
          <el-col :span="24" :key="idx">
            <el-form-item
              v-if="idx >= 11 && idx <= 12"
              size="small"
              :prop="form.id"
              :label="form.label"
              :rules="form.rules"
            >
              <el-col :span="6">
                <el-input
                  disabled
                  v-if="form.type == 'text' || form.type == 'number'"
                  v-model="shipToAddress[form.id]"
                  :type="form.type"
                  :placeholder="`Please input ${form.label}`"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </template>
      </el-row>

      <el-row>
        <template v-for="(form, idx) in formShipToAddress">
          <el-col :span="12" :key="idx">
            <el-form-item
              v-if="idx >= 13 && idx <= 16"
              size="small"
              :prop="form.id"
              :label="form.label"
              :rules="form.rules"
            >
              <el-col :span="12">
                <el-input
                  disabled
                  v-if="form.type == 'text' || form.type == 'number'"
                  v-model="shipToAddress[form.id]"
                  :type="form.type"
                  :placeholder="`Please input ${form.label}`"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ["DataCustomerAddress", "Id", "OptionsActive"],
  name: "FormShipToAddress",
  computed: {
    shipToAddress() {
      if (this.DataCustomerAddress.listAddress.length > 0) {
        let tempId;
        if (this.Id === null) {
          tempId = this.DataCustomerAddress.listAddress[0].oracleSiteUseId
        } else {
          tempId = this.Id
        }
        const filteredCustomerAddress = this.DataCustomerAddress.customerAddress.filter(item => {
          return item.oracleSiteUseId == tempId && item.addressType == "SHIP_TO";
        });
        return filteredCustomerAddress[0];
      } else {
        return {}
      }
    },
    formShipToAddress() {
      return [
        {
          type: "number",
          id: "oracleShipToSiteUseId",
          label: "Oracle Ship To Site Use Id",
          rules: []
        },
        {
          type: "text",
          id: "categoryCode",
          label: "Category Code",
          rules: []
        },
        {
          type: "text",
          id: "country",
          label: "Country",
          rules: []
        },
        {
          type: "text",
          id: "province",
          label: "Province",
          rules: []
        },
        {
          type: "text",
          id: "city",
          label: "City",
          rules: []
        },
        {
          type: "text",
          id: "state",
          label: "State",
          rules: []
        },
        {
          type: "textarea",
          id: "address",
          label: "Address",
          rules: []
        },
        {
          type: "text",
          id: "postalCode",
          label: "PostalCode",
          rules: []
        },
        {
          type: "text",
          id: "latitudes",
          label: "Latitude",
          rules: []
        },
        {
          type: "text",
          id: "longitudes",
          label: "Longitude",
          rules: []
        },
        {
          type: "text",
          id: "primaryPhoneNumber",
          label: "Phone Number",
          rules: []
        },
        {
          type: "text",
          id: "contactPerson",
          label: "Contact Person Name",
          rules: []
        },
        {
          type: "text",
          id: "contactPhoneNumber",
          label: "Contact Person Phone Number",
          rules: []
        },
        {
          type: "text",
          id: "dateCreated",
          label: "Oracle Date Created",
          rules: []
        },
        {
          type: "text",
          id: "dateUpdated",
          label: "Oracle Date Update",
          rules: []
        },
        {
          type: "text",
          id: "userCreated",
          label: "Oracle User Created",
          rules: []
        },
        {
          type: "text",
          id: "userUpdated",
          label: "Oracle User Update",
          rules: []
        }
      ];
    }
  }
};
</script>

